import { defineComponent as _defineComponent } from 'vue'
import { Icon } from '@iconify/vue2'
import { onClickOutside } from '@vueuse/core'
import { computed, ref, toRefs, watch } from 'vue'
import Checkbox from '../../../../components/ui/checkbox/Checkbox.vue'
import DropdownColunas from './DropdownColunas.vue'
import { SortOption } from './dtos/SortOption.dto'
import { SortDirection } from './enums/SortDirection.enum'
import { TableColumn } from './dtos/TableColumn.dto'
import TableHeaderCell from './TableHeaderCell.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTable',
  props: {
    data: null,
    colunas: null,
    displayMode: { type: Boolean, default: false },
    checked: null
  },
  emits: ["sort", "update:checked"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'sort', value: SortOption): void
	(event: 'update:checked', value?: string[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { data: any[], colunas: TableColumn[], displayMode: boolean, checked?: string[] };





watch(
	() => props.checked,
	(value) => {
		emit('update:checked', value)
	},
)

const { data } = toRefs(props)

const checkAll = ref(false)

watch(checkAll, (value) => {
	if (value) {
		emit(
			'update:checked',
			data.value.map((dado) => dado.id),
		)
	} else {
		emit('update:checked', [])
	}
})

const allColumnsKeys = computed(() => {
	return props.colunas.map((d) => d.key)
})

const columnsEnabled = ref(allColumnsKeys.value)

// columnsEnabled nasce com as colunas do mount; uma coluna que o pai passe a enviar
// depois (ex.: coluna opcional ativada pelo usuário) ficaria filtrada para sempre.
watch(allColumnsKeys, (keys, oldKeys) => {
	const addedKeys = keys.filter(
		(key) => !oldKeys.includes(key) && !columnsEnabled.value.includes(key),
	)
	if (addedKeys.length) columnsEnabled.value = [...columnsEnabled.value, ...addedKeys]
})

function handleSort(key: string, direction?: SortDirection) {
	emit('sort', { key, direction })
}

const dropdownColunas = ref()
const openColunas = ref(false)

onClickOutside(dropdownColunas, () => {
	openColunas.value = false
})

return { __sfc: true,emit, props, data, checkAll, allColumnsKeys, columnsEnabled, handleSort, dropdownColunas, openColunas, Icon, Checkbox, DropdownColunas, TableHeaderCell }
}

})